/* eslint-disable */
import React, { Component } from 'react';
import cn from 'classnames';
import AnnotationForm from './AnnotationForm';
import './Annotation.scss';

import { debounce, escapeRegExp } from 'lodash';

// A to be on top or above B, but very close to it
const getDiff = (A, B, offset = 6) => {
  const a = A.getBoundingClientRect();
  const b = B.getBoundingClientRect();

  let diff = 0;
  if (a.top < b.top) {
    diff += a.bottom - b.top + offset;
  } else {
    diff += a.top - b.bottom - offset;
  }
  return diff;
};

// sometimes learnosity returns mathml and we need to remove it
const getNodeText = (htmlStr) => {
  const elem = document.createElement('div');
  elem.innerHTML = htmlStr;
  let i, el, exp;
  const str = [];
  for (i = elem.childNodes.length - 1; i >= 0; i--) {
    el = elem.childNodes[i];
    if (el.nodeType === document.TEXT_NODE) {
      str.unshift(exp ? el.data.replace(exp, '') : el.data);
      exp = null;
    } else {
      exp = new RegExp(`${escapeRegExp(el.textContent)}$`);
    }
  }
  return str.join('');
};

const StickyNote = ({ item, position, showModal, isImpersonating }) => (
  <button
    className={cn('Annotation--side-icon', item.highlight.color)}
    onClick={() => showModal(AnnotationForm, { ...item, isImpersonating })}
    style={position}
  >
    <div className="sticky-note" />
  </button>
);

const StickyList = ({ items, position, showModal, isImpersonating }) => (
  <ul className="Annotation--side-list" style={position}>
    {items.map((item, i) => (
      <StickyNote
        key={i}
        item={item}
        showModal={showModal}
        isImpersonating={isImpersonating}
      />
    ))}
  </ul>
);

class Annotation extends Component {
  static displayName = 'AnnotationContainer';

  constructor(props) {
    super(props);

    const { reference: currentItem } = this.props.app.getCurrentItem();
    const vw = document.body.getBoundingClientRect().width;

    this.state = {
      isVisible: false,
      wasVisible: false,
      isActive: false,
      currentItem,
      viewportWidth: vw,
      isMobile: vw <= 768,
    };

    this.debouncedOpen = debounce(this.openPalette, 300);

    const itemsApp = this.props.app;
    itemsApp.on('app:ready', () => {
      this._annotationsApp = itemsApp.annotationsApp();
      const thModule = this._annotationsApp.module('texthighlight');

      setTimeout(() => {
        thModule.render();
        thModule.show();
        this.forceUpdate();
      }, 1000);
    });
  }

  componentDidMount() {
    const items = this.props.app;

    items.on('app:ready', () => {
      // Save container references
      this._popover = document.querySelector(
        '.lrn-annotations-c-popover',
      ).parentElement;
      this._container = document.querySelector('.slides-container');

      const app = this._annotationsApp;
      this._utils = app.module('texthighlight').utils;
      this.setupTool();

      // Setup listeners
      items.on('item:changed', this.setCurrentItem);
      app.on('texthighlight:add', this.setupTool);
      app.on('texthighlight:add', this.createHighlight);
      app.on('texthighlight:remove', this.deleteHighlight);
      document.addEventListener('selectionchange', this.debouncedOpen);
      // Prevent flickering when changing from one question to another
      items.on('item:changing', () => this.setVisibility(null, true));
      items.on('item:changed', () => this.setVisibility(null, true));

      // Save text selection for later
      this._annotationsApp
        .module('texthighlight')
        .setFormatRenderResult((e) => {
          const {
            _text,
            _renderingInstance: {
              options: { className },
            },
          } = e;
          const color = className.reduce(
            (p, n) => n.match(/color--(.+)$/) || p,
            [,],
          )[1];

          this._currentHighlight = { selection: getNodeText(_text), color };
        });
    });
  }

  componentWillUnmount() {
    const app = this._annotationsApp;
    const items = this.props.app;
    if (app) {
      app.off('texthighlight:add', this.createHighlight);
      app.off('texthighlight:add', this.setupTool);
      app.off('texthighlight:remove', this.deleteHighlight);
    }
    items.off('item:changing', () => this.setVisibility(null, true));
    items.off('item:changed', () => this.setVisibility(null, true));
    document.removeEventListener('selectionchange', this.debouncedOpen);
  }

  setCurrentItem = () => {
    const { reference: currentItem } = this.props.app.getCurrentItem();
    this.setState({ currentItem });
  };

  deleteHighlight = () => {
    const { isImpersonating } = this.props;
    const popover = this._popover.querySelector('.lrn-annotations-c-popover');
    popover.style.visibility = 'hidden';
    if (!isImpersonating) {
      this._annotationsApp.save();
    }
  };

  createHighlight = ({ id, endContainerPath: path, endOffset: offset }) => {
    const popover = this._popover.querySelector('.lrn-annotations-c-popover');
    const { isImpersonating, showModal } = this.props;
    popover.style.visibility = 'hidden';
    if (!isImpersonating) {
      this._annotationsApp.save();
    }
    if (!this.state.isActive) return;
    const { currentItem: item } = this.state;
    const highlight = { id, item, path, offset, ...this._currentHighlight };
    delete this._currentHighlight;
    this.setState({ isActive: false }, () => {
      showModal(AnnotationForm, { highlight, isImpersonating });
    });
  };

  openPalette = () => {
    if (this.state.isVisible) {
      const popover = this._popover.querySelector('.lrn-annotations-c-popover');
      if (
        popover &&
        window.getSelection().toString() &&
        !this._makingPaletteVisible
      ) {
        popover.style.visibility = 'hidden';
        popover.style.top = '0px';
        const makePaletteVisible = () => {
          const palette = popover.querySelector(
            '.lrn-annotations-c-popover__palette',
          );
          if (!palette) {
            if (!this._makingPaletteVisible) {
              this._makingPaletteVisible = true;
            }
            const toggle = popover.querySelector(
              '.lrn-annotations-c-button--togglePalette',
            );
            toggle.click();
            setTimeout(makePaletteVisible, 50);
            return;
          }
          this._makingPaletteVisible = false;
          popover.style.opacity = 1;
          palette.style.visibility = 'visible';
          const block = window.getSelection().getRangeAt(0);
          popover.style.top = `${
            parseInt(popover.style.top) - getDiff(palette, block, 10)
          }px`;
          this.renderStickyNoteIcon();
        };
        setTimeout(makePaletteVisible, 200);
      }
    }
  };

  /**
   * Set up popover contents
   * */
  setupTool = () => {
    const { isVisible } = this.state;
    const listAction = isVisible ? 'remove' : 'add';
    this._popover.classList[listAction]('highlighter-is-disabled');
    const markings = this._container.querySelectorAll(
      '.lrn-annotations-texthighlight-marking',
    );
    for (let marking of markings) {
      marking.removeEventListener('click', this.renderRemoveButton);
      if (isVisible) {
        marking.addEventListener('click', this.renderRemoveButton);
      }
    }
  };

  /**
   * Render annotation icon next to the colors
   * */
  renderStickyNoteIcon = () => {
    if (this._popover.querySelector('.sticky-note')) {
      return;
    }
    const palette = this._popover.querySelector(
      '.lrn-annotations-c-popover__palette',
    );
    const item = document.createElement('li');
    const btn = document.createElement('button');
    btn.className = 'sticky-note';
    item.appendChild(btn);
    palette.appendChild(item);
    btn.addEventListener('click', this.createAnnotation);
  };

  /**
   * Render remove icon and update label
   * */
  renderRemoveButton = () => {
    const popover = this._popover.querySelector('.lrn-annotations-c-popover');
    const marking = document.querySelector(
      '.lrn-annotations-texthighlight-marking--active',
    );
    window.getSelection().removeAllRanges();
    popover.style.visibility = null;
    popover.style.opacity = null;
    if (this._popover.querySelector('.remove-highlight')) {
      if (this.state.isMobile) {
        popover.style.top = `${
          parseInt(popover.style.top) - getDiff(popover, marking)
        }px`;
      }
      return;
    }
    const button = this._popover.querySelector(
      '.lrn-annotations-c-button--removeHighlight',
    );
    if (!button) {
      return;
    }
    const label = button.querySelector('.lrn-annotations-c-button__label');
    label.innerText = 'Remove Highlight';
    const icon = document.createElement('div');
    icon.className = 'remove-highlight';
    if (this.state.isMobile) {
      popover.style.top = `${
        parseInt(popover.style.top) - getDiff(popover, marking)
      }px`;
    }
    button.prepend(icon);
    button.removeChild(button.querySelector('.lrn-annotations-icon'));
    const pointer = this._popover.querySelector(
      '.lrn-annotations-c-popover__pointer',
    );
    pointer.style.display = 'none';
  };

  /**
   * Switch form highlight-only to highlight+annotation
   * */
  createAnnotation = () => {
    this.setState({ isActive: true }, () => {
      const palette = this._popover.querySelector(
        '.lrn-annotations-c-popover__palette',
      );
      const colorBtn = palette.querySelector('li.selected > button');
      colorBtn.click();
    });
  };

  /**
   * Show or hide annotations
   * */
  setVisibility(isVisible, isChanging = false) {
    const vw = document.body.getBoundingClientRect().width;
    const newState = { isVisible, viewportWidth: vw, isMobile: vw <= 768 };
    if (isChanging) {
      const { wasVisible, isVisible: nowVisible } = this.state;
      if (nowVisible) {
        newState.isVisible = false;
        newState.wasVisible = true;
      } else {
        newState.isVisible = wasVisible;
      }
    } else {
      newState.wasVisible = isVisible;
    }
    this.setState(newState, () => {
      const listAction = !isVisible ? 'add' : 'remove';
      this._popover.classList[listAction]('highlighter-is-disabled');
      this.setupTool();
    });
  }

  filterByQuestion = (annotations = [], initial) => {
    const { currentItem } = this.state;
    return Object.values(
      (annotations || []).reduce((result, annotation) => {
        const {
          highlight: { item, path, offset },
        } = annotation;
        if (item !== currentItem) {
          return result;
        }
        const highlight = this._utils.deserializePath(path, offset);
        if (!highlight) {
          return result;
        }
        const { bottom: marker } =
          highlight.node.parentElement.getBoundingClientRect();
        if (!result[marker]) {
          result[marker] = {
            item: annotation,
            position: { top: marker + initial.top, left: initial.left },
          };
        } else {
          result[marker].items = result[marker].items || [result[marker].item];
          delete result[marker].item;
          result[marker].items.push(annotation);
        }
        return result;
      }, {}),
    );
  };

  render() {
    const { currentItem } = this.state;
    const {
      showModal,
      annotationData: {
        annotationRequests: { main: Composed },
        variables,
      },
      isImpersonating,
    } = this.props;
    return (
      <Composed variables={variables} isImpersonating={isImpersonating}>
        {({
          annotationDataRequest: {
            loading,
            data: { learnosityAssignmentAnnotations: results },
          },
        }) => {
          const widget =
            this._container &&
            this._container.querySelector(
              `.learnosity-item[data-reference="${currentItem}"] .lrn_widget`,
            );
          if (!widget || loading) {
            return null;
          }
          const viewport = widget.getBoundingClientRect();
          if (Object.values(viewport.toJSON()).every((x) => x === 0)) {
            return null;
          }
          // Leaving both selectors to accomodate for the readiness check, as well as the player
          const topWrapper = document.querySelector(
            '.PlayerModeContainer--header, .top_bar_wrapper, .top-right-wrapper',
          );

          if (!topWrapper) {
            return;
          }

          const top_bar = topWrapper.getBoundingClientRect();
          const offset = {
            top: window.scrollY - top_bar.height - 21,
            left: viewport.right,
          };
          return (
            <div className="Annotation--container">
              {this.filterByQuestion(results, offset).map((result, i) =>
                result.items ? (
                  <StickyList
                    key={i}
                    {...result}
                    showModal={showModal}
                    isImpersonating={isImpersonating}
                  />
                ) : (
                  <StickyNote
                    key={i}
                    {...result}
                    showModal={showModal}
                    isImpersonating={isImpersonating}
                  />
                ),
              )}
            </div>
          );
        }}
      </Composed>
    );
  }
}

export default Annotation;
